import { StudentSidebar } from './StudentSidebar';
import { StudentBottomNavigation } from './StudentBottomNavigation';
import '../styles/tailwind.css';

interface StudentAppLayoutProps {
  children: React.ReactNode;
}

export function StudentAppLayout({ children }: StudentAppLayoutProps) {
  return (
    <div className="lyw-container min-h-screen bg-gray-50">
      <StudentSidebar />
      <main className="sm:ml-72 pb-16 sm:pb-0">
        {children}
      </main>
      <StudentBottomNavigation />
    </div>
  );
}
